export const metricTrendFragment = `
  currentValue
  previousValue
  percentageChange
`;
